import React, { FunctionComponent } from 'react'
import { Currency, CurrencyConversionDto } from '../types'
import { useCurrencyConversionsByEmployee } from '../graphql/currency-conversion/hooks/useCurrencyConversionsByEmployee'

type CurrencyProviderProps = {
  employeeId: string
}

const CurrencyContext = React.createContext<{ currency: Currency; currencyConversionData: CurrencyConversionDto[] }>({
  currency: Currency.Eur,
  currencyConversionData: [],
})

const CurrencyFromContractProvider: FunctionComponent<CurrencyProviderProps> = ({ employeeId, children }) => {
  let currency = Currency.Eur
  let currencyConversionData: CurrencyConversionDto[] = []
  // BE CAREFUL: THIS LOGIC RETRIEVES CURRENCY CONVERSION DATA STARTING FROM THE CURRENCY OF THE EMPLOYEE CONTRACT.
  // IT IS STRICTLY RELATED TO THE ORDERING OF OPERATIONS OF "duplicateAndDismissObjectiveInMeeting" FUNCTION INSIDE "objective.resolver.ts" FILE.
  // MORE IN DETAILS, WE ARE TALKING ABOUT WHEN WE RETRIEVE CONVERSION RATES FOR AMOUNT CONVERSION. AN EXTRA COMMENT IS PRESENT INSIDE THE TARGET METHOD.
  const { data } = useCurrencyConversionsByEmployee(employeeId)

  if (!!data && !!data.getCurrencyConversionsByEmployee) {
    currency = data.getCurrencyConversionsByEmployee.contractCurrency
    currencyConversionData = data.getCurrencyConversionsByEmployee.currencyConversionData
  }

  return <CurrencyContext.Provider value={{ currency, currencyConversionData }}>{children}</CurrencyContext.Provider>
}

const useCurrency = (): { currency: Currency; currencyConversionData: CurrencyConversionDto[] } => {
  return React.useContext<{ currency: Currency; currencyConversionData: CurrencyConversionDto[] }>(CurrencyContext)
}

export { CurrencyContext, CurrencyFromContractProvider, useCurrency }
